<div *ngIf="isLoading" class="overlay">
    <mat-spinner></mat-spinner>
<div class="loader-message">
    {{ loaderMsg }}
  </div>
</div>
<div class="main-container">
    <div>
        <div class="buttons-container">
            <ul class="buttons-container__list">
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="downloadWorkItem()"
                        [disabled]="false">
                        <mat-icon>download</mat-icon>
                        Print/Save
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button short-button" (click)="showEmailModal()"
                        [disabled]="false">
                        <mat-icon>email</mat-icon>
                        Email
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button short-button" (click)="copyLink()"
                        [disabled]="false">
                        <mat-icon>link</mat-icon>
                        Link
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="uploadFileWorkItem()"
                        [disabled]="false">
                        <mat-icon>attach_file</mat-icon>
                        Add Attachment
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="showViewHistory()"
                        [disabled]="false">
                        <mat-icon>history</mat-icon>
                        View Workflow History
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="showDocumentHistory()"
                        [disabled]="false">
                        <mat-icon>history</mat-icon>
                        View Document History
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="showViewNotes()"
                        [disabled]="false">
                        <mat-icon>group_work</mat-icon>
                        {{ workFlowNotesMenu }}
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="showDocumentNotesAdmin()"
                        [disabled]="false">
                        <mat-icon>description</mat-icon>
                        {{ documentNotesMenu }}
                    </button>
                </li>
                <li class="buttons-container__item">
                    <button type="button" class="buttons-container__button" (click)="showWIEmailModal()"
                        [disabled]="true">
                        <mat-icon>mail_outline</mat-icon>
                        Email Requestor
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <div>
        <div class="flex-container">
            <div class="buttons-container" style="padding-left: 14px;padding-right: 14px; border: none !important;">
                <ul class="buttons-container__list" style="background: none !important;">
                    <li class="buttons-container__item" *ngIf="isRoutingButton" style="padding-bottom: 10px;">
                        <div *ngIf="isRoutingBtnLoading && !isRetrieval">
                            <mat-spinner diameter="20"></mat-spinner>
                        </div>
                        <div *ngFor="let btn of routingButtons">
                            <button type="button" class="buttons-container__button docviewer-move-button"
                                (click)="moveWorkItem(btn)"
                                [hidden]="isRetrieval || (!isAdvanceInitiatorAsApprover && AdvanceInitiator)"
                                [disabled]="!isAdmin && btn.toQueueName === 'Finish'">
                                {{btn.toQueueName}}
                            </button>
                        </div>
                    </li>
                    <mat-form-field appearance="outline" class="full-width buttons-container__item route-mat-form-field" *ngIf="!isRoutingButton && !reRoute" [hidden]="isRetrieval"> 
                        <mat-select [(value)]="selectedQueue" placeholder="Select a Queue" (selectionChange)="moveWorkItem($event.value)">
                            <ng-container *ngIf="!isRoutingBtnLoading; else loadingTemplate">
                                <mat-option disabled="true" value="">Select a Queue</mat-option>
                                <mat-option *ngFor="let route of setRoutingButtons" [value]="route"
                                    [disabled]="!isAdmin && route.toQueueName === 'Finish'">
                                    {{ route.toQueueName }}
                                </mat-option>
                            </ng-container>
                            <ng-template #loadingTemplate>
                                <mat-option disabled>
                                    <mat-spinner diameter="20"></mat-spinner>
                                </mat-option>  
                            </ng-template> 
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width buttons-container__item route-mat-form-field" *ngIf="!isRoutingButton && reRoute" [hidden]="isRetrieval">
                        <mat-select [(value)]="selectedQueue" placeholder="Select a Queue" (selectionChange)="moveWorkItem($event.value)">
                            <ng-container *ngIf="!isRoutingBtnLoading; else loadingTemplate">
                                <mat-option disabled="true" value="">Select a Queue</mat-option>
                                <mat-option *ngFor="let route of resetRoutingButtons" [value]="route"
                                    [disabled]="!isAdmin && route.toQueueName === 'Finish'">
                                    {{ route.toQueueName }}
                                </mat-option>
                            </ng-container>
                            <ng-template #loadingTemplate>
                                <mat-option disabled>
                                    <mat-spinner diameter="20"></mat-spinner>
                                </mat-option>
                            </ng-template> 
                        </mat-select>
                    </mat-form-field>

                    <li class="buttons-container__item">
                        <button type="button" class="buttons-container__button  docviewer-move-button"
                            [ngClass]="{ 'retrunbtndisable': !canReturn }" (click)="moveWorkItem('-1')"
                            [hidden]="isRetrieval || previousQueueName === 'start'" [disabled]="!canReturn">
                            Return
                        </button>
                    </li>

                    <mat-form-field appearance="outline"style="min-width: 292px; !important" class="full-width buttons-container__item route-mat-form-field" [hidden]="isRetrieval || (!isAdvanceInitiatorAsApprover && AdvanceInitiator)">
                        <mat-select [(value)]="selDocumentType" name="loadNextWorkItem" placeholder="Select an option to load next work item" (selectionChange)="getNextWorkItem()">
                            <mat-option disabled="true" value="">Select an option to load next work item</mat-option>
                            <mat-option value="all">All</mat-option>
                            <mat-option value="none">None</mat-option>
                            <mat-option *ngFor="let dt of documentTypeForQueue" [value]="dt">
                                {{ dt.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="buttons-container__item push-end">
                        <li>
                            <button mat-raised-button color="warning" class="reset" [disabled]="false" (click)="closeWorkitem()">Close</button>
                        </li>
                    </div>
                </ul>
            </div>
        </div>
    </div>
     
    <div class="main-content">
        <mat-accordion [multi]="true">
            <mat-expansion-panel style="background-color: white !important;margin-bottom: 20px;" [expanded]="true">
                <mat-expansion-panel-header style="height: 32px;background-color: #009546;">
                    <mat-panel-title>
                        <h2 mat-dialog-title class="dialog-header">
                            <div class="header-left" style="font-size: 13px !important;">
                                <mat-icon class="header-icon">description</mat-icon>
                                LINE ITEMS / GL ENTRY
                            </div>
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                 
                <div> 
                    <app-line-items-gl-entry #lineItemsGlEntry *ngIf="docId" [abbyyBatchId]="abbyyBatchId" [docId]="docId"
                        [abbyyDocId]="abbyyDocId" [isFromDocViewer]="true" [isEditableGLEntryTable]="isEditableGLEntryTable" [isWIInCustOrNonPOApprovalQueues]="isWIInCustOrNonPOApprovalQueues" [isCustGLEntryTableDisplay]="isCustGLEntryTableDisplay" [isCustWorkFlowBaName]="isCustWorkFlowBaName" [isRetrieval]="isRetrieval" [documentTypeId]="documentTypeIdForGL" [queueId]="pQueueId" [workflowId]="workFlowID" [isVendorIntercompany]="isVendorIntercompany" [mappedCompanyCode]="mappedCompanyCode" (glEntriesCountChanged)="onGlEntriesCountChanged($event)" (saveCompleted)="onGLEntrySaveCompleted()">
                    </app-line-items-gl-entry>
                </div> 
            </mat-expansion-panel>

            <mat-expansion-panel style="background-color: white !important;margin-bottom: 20px;" [expanded]="true">
                <mat-expansion-panel-header style="height: 32px;background-color: #009546;">
                    <mat-panel-title>
                        <h2 mat-dialog-title class="dialog-header">
                            <div class="header-left" style="font-size: 13px !important;">
                                <mat-icon class="header-icon">picture_as_pdf</mat-icon>
                                DOCUMENTS AND ATTACHMENTS
                            </div>
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div style="display: flex;">
                    <div class="iframe-panel">
                        <iframe class="iframeStyles" [hidden]="iframeCollapsed" [src]="documentSourceUrl | safeUrl" title="Document Viewer"></iframe>
                    </div>

                    <div style="padding: 0 0 0 20px;width:30%;">
                        <div class="button-group">
                            <button mat-button class="attach-button" [ngClass]="{ 'active-class': isDocumentView }" (click)="isDocumentView = true">Documents and Attachments</button> 
                        </div>

                        <mat-card style="border: solid 1px #dbdbdb;border-radius: 0px;" *ngIf="isDocumentView">
                            <mat-card-content> 
                                <mat-nav-list>
                                    <ng-container *ngIf="!isAttachmentLoading; else loadingAttachment">
                                        <mat-list-item *ngFor="let doc of documentList" tabindex="0" role="button" [class.selected]="doc === selectedDocument"
                                        (click)="updateIframe(doc)" (keydown)="onDocumentKeydown($event, doc)">
                                        {{ doc.fileName }}
                                        </mat-list-item>
                                    </ng-container>
                                    <ng-template #loadingAttachment>
                                        <mat-list-item disabled>
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </mat-list-item>
                                    </ng-template> 
                                        
                                </mat-nav-list>
                            </mat-card-content>
                        </mat-card>

                        <mat-card style="border: solid 1px #dbdbdb;" *ngIf="!isDocumentView">
                            <mat-card-content>
                                <mat-tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor">
                                    <ng-container *ngIf="!isBatchViewLoading; else loadingBatchView">
                                        <!-- Leaf node -->
                                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding tabindex="0" (click)="loadPage(node.value, node.imageId)"
                                            [ngClass]="{ 'selected--child-node': selectedNodeValue === node.value }" (keydown)="onTreeNodeKeydown($event, node)">
                                            <button mat-icon-button disabled></button>
                                            {{ node.name }}: [{{ node.value }}]
                                        </mat-tree-node>
                                        
                                        <!-- Expandable node -->
                                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                                            [ngClass]="{ 'selected-parent-node': selectedNodeValue === node.value }">
                                            <div matTreeNodePadding>
                                                <button mat-icon-button (click)="toggleNode(node)">
                                                    <mat-icon>
                                                        {{ isNodeExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                                    </mat-icon>
                                                </button>
                                                {{ node.name }}: {{ node.value }}
                                            </div>
                                            <div *ngIf="isNodeExpanded(node)">
                                                <ng-container matTreeNodeOutlet></ng-container>
                                            </div>
                                        </mat-nested-tree-node>
                                    </ng-container>
                                    <ng-template #loadingBatchView>
                                        <mat-tree-node disabled>
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </mat-tree-node>
                                    </ng-template>
                                </mat-tree>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel style="background-color: white !important;margin-bottom: 20px;" [expanded]="true">
                <mat-expansion-panel-header style="height: 32px;background-color: #009546;">
                    <mat-panel-title>
                        <h2 mat-dialog-title class="dialog-header">
                            <div class="header-left" style="font-size: 13px !important;">
                                <mat-icon class="header-icon">description</mat-icon> {{ 'PROPERTIES' }} ({{selectedPreferenceValue}} ZONE)
                            </div>
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div>
                    <div class="index-fields-panel"> 
                        <div style="border: solid 1px #dbdbdb;">
                            <form [formGroup]="indexForm" (ngSubmit)="saveWorkItem()">
                                <div formArrayName="fields" class="fields-grid scroll-indexing-fields">
                                    <ng-template  *ngIf="isIndexFieldsLoading; else indexFields">
                                        <div  class="field-item">
                                            <mat-spinner diameter="100"></mat-spinner>
                                        </div>
                                    </ng-template>
                                    <ng-template #indexFields>
                                        <div *ngFor="let field of fieldArray.controls; let i = index" [formGroupName]="i" class="field-item" #indexFields>
                                            <div *ngIf="field.value.controlName === 'TEXT_BOX'" class="field-row">
                                                <label class="index-lable">
                                                    <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                                </label>
                                                <mat-form-field [ngClass]="{ 'mandatory-highlight': field.value.isMandatory && isDynamicMandatoryActive }">
                                                    <input matInput type="text" formControlName="valueAsString" [readonly]="field.value.isReadOnly">
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('required')">
                                                        This field is required.
                                                    </mat-error>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('maxTotalLength')">
                                                        Total length exceeds allowed limit.
                                                    </mat-error>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('decimalTooLong')">
                                                        Too many digits after the decimal point.
                                                    </mat-error>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('notNumeric')">
                                                        Enter a valid number.
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        
                                            <div *ngIf="field.value.controlName === 'TEXT_AREA'" class="field-row">
                                                <label class="index-lable">
                                                    <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                                </label>
                                                <mat-form-field appearance="fill" [ngClass]="{ 'mandatory-highlight': field.value.isMandatory && isDynamicMandatoryActive }">
                                                    <textarea matInput rows="2" formControlName="valueAsString" [readonly]="field.value.isReadOnly"></textarea>
                                        
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('required')">
                                                        This field is required.
                                                    </mat-error>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('maxTotalLength')">
                                                        Total length exceeds allowed limit.
                                                    </mat-error>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('notAllowedCharacters')">
                                                        Contains invalid characters.
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        
                                            <div *ngIf="field.value.controlName === 'CHECK_BOX'" class="field-row">
                                                <label class="index-lable">
                                                    <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                                </label>
                                                <mat-checkbox formControlName="valueAsString"></mat-checkbox>
                                                <mat-error *ngIf="field.get('valueAsString')?.hasError('required')">
                                                    This checkbox is required.
                                                </mat-error>
                                            </div>
                                        
                                            <div *ngIf="field.value.controlName === 'COMBO_BOX'" class="field-row">
                                                <label class="index-lable">
                                                    <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                                </label>
                                                <mat-form-field>
                                                    <mat-select formControlName="valueAsString" placeholder="Select a value">
                                                        <mat-option [value]="">Select a value</mat-option>
                                                        <mat-option *ngFor="let option of field.value.comboValues" [value]="option.comboValue">
                                                            {{ option.comboValue }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('required')">
                                                        This selection is required.
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        
                                            <div *ngIf="field.value.controlName === 'DATE'" class="field-row">
                                                <label class="index-lable">
                                                    <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                                </label>
                                                <mat-form-field>
                                                    <input matInput [matDatepicker]="picker" formControlName="valueAsString"
                                                        [value]="parseDateValue(field.value.valueAsString, field.value.fieldDateFormat?.defaultFormat)"
                                                        [placeholder]="getDatePlaceholder(i)" (dateChange)="onDateChange($event)"
                                                        (focus)="onDatepickerOpened(i)" />
                                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                    <mat-error *ngIf="field.get('valueAsString')?.hasError('required')">
                                                        Date is required.
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        
                                            <div *ngIf="field.value.controlName === 'LABEL'" class="field-row">
                                                <label class="index-lable">
                                                    <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                                </label>
                                                <span class="label-value">{{ field.getRawValue().valueAsString ? field.getRawValue().valueAsString : 'NA' }}</span>
                                            </div>
                                            <div *ngIf="field.value.controlName === 'USER_AUTOCOMPLETE'" class="field-row">
                                            <label class="index-lable">
                                                <span *ngIf="field.value.isMandatory" class="required-star">*</span>{{ field.value.displayName }}
                                            </label>

                                            <mat-form-field class="reassign-field" appearance="fill" [ngClass]="{ 'mandatory-highlight': field.value.isMandatory && isDynamicMandatoryActive }">
                                                <input type="text"
                                                    matInput
                                                    placeholder="Search Approver"
                                                    aria-label="Re-Assign To"
                                                    formControlName="valueAsString"
                                                    [readonly]="field.value.isReadOnly"
                                                    [matAutocomplete]="auto">
                                                <mat-autocomplete #auto="matAutocomplete">
                                                @for (gpid of userFilteredOptionsMap[i] | async; track gpid) {
                                                    <mat-option [value]="gpid?.value">{{ gpid?.name }}</mat-option>
                                                }
                                                </mat-autocomplete>

                                                <!-- Validation errors -->
                                                <mat-error *ngIf="field.get('valueAsString')?.hasError('required')">
                                                This field is required.
                                                </mat-error>
                                                <mat-error *ngIf="field.get('valueAsString')?.hasError('notAllowedCharacters')">
                                                Contains invalid characters.
                                                </mat-error>
                                            </mat-form-field>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>

                                <div class="save-button-container">
                                    <button class="saveIndexFieldsBtn" mat-raised-button color="primary" [disabled]="isReadOnly || indexForm.invalid && isRetrieval" type="submit">Save</button>
                                </div>
                            </form>
                        </div> 
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion> 
    </div>
</div>